<p-sidebar [styleClass]="styleClass" [(visible)]="visible" [position]="position" [appendTo]="appendTo"
  [showCloseIcon]="false" [dismissible]="dismissible" [modal]="modal" (onHide)="close()">
  <div class="wrapper">
    <div *ngIf="headerTemplate || showHeader" class="header" [ngClass]="{'header-boarder': headerBoarder}"
      [style.background-color]="headerColor">
      <ng-container *ngTemplateOutlet="headerTemplate ? headerTemplate : defaultHeader"></ng-container>
    </div>
    <div class="body" [style.background-color]="bodyColor">
      <ng-scrollbar class="flex-grow-1">
        <ng-content></ng-content>
      </ng-scrollbar>
      <ngx-loading [show]="loading"
        [config]="{primaryColour: 'rgb(255,114,0,0.75)', secondaryColour: 'rgb(255,114,0,0.75)', tertiaryColour: 'rgb(255,114,0,0.75)'}">
      </ngx-loading>
    </div>
    <div *ngIf="footerTemplate || showFooter" class="footer" [ngClass]="{'footer-boarder': footerBoarder}"
      [style.background-color]="footerColor">
      <ng-container *ngTemplateOutlet="footerTemplate ? footerTemplate : defaultFooter"></ng-container>
    </div>
  </div>
</p-sidebar>

<ng-template #defaultHeader>
  <div class="w-100 d-flex px-3 align-items-center">
    <div>
      <fa-icon *ngIf="showCloseIcon" icon="times" size="2x" class="float-left me-4" style="cursor: pointer"
        (click)="close('dismiss')">
      </fa-icon>
      <fa-icon *ngIf="showBackIcon" icon="arrow-left" size="2x" class="float-left me-4" style="cursor: pointer"
        (click)="close('back')">
      </fa-icon>
    </div>
    <div class="w-100">
      <div *ngIf="header" class="app-page-title">{{header}}</div>
      <ng-content select="header"></ng-content>
    </div>
  </div>
</ng-template>

<ng-template #defaultFooter>
  <div class="w-100 d-flex p-3 justify-content-end">
    <button class="btn btn-primary" (click)="clickSave()" [disabled]="btnSaveDisabled"
      [ladda]="btnSaveLadda">{{btnSaveLabel}}</button>
  </div>
</ng-template>